<template>
  <div>
    <communication-item-text v-if="isText(comm)" :text="comm">
      <template v-slot:column>
        <communication-item-records
          :communication-log="comm"
        ></communication-item-records>
      </template>
    </communication-item-text>

    <communication-item-call
      v-if="isCall(comm)"
      :call="comm"
      @transcript="openTranscriptModal"
    >
      <template v-slot:column>
        <communication-item-records
          :communication-log="comm"
        ></communication-item-records>
      </template>
    </communication-item-call>

    <communication-item-email v-if="isEmail(comm)" :email="comm">
      <template v-slot:column>
        <communication-item-records
          :communication-log="comm"
        ></communication-item-records>
      </template>
    </communication-item-email>

    <modal-container>
      <modal-default
        ref="transcriptModal"
        :title="transcript.title"
        :subtitle="transcript.subtitle"
        is-wide
        @close="closeTranscriptModal"
      >
        <div class="transcript-modal">
          <section-basic title="Summary">
            <p>
              <template v-if="transcript.data.summary">{{
                transcript.data.summary
              }}</template>
              <template v-else>No Summary</template>
            </p>
          </section-basic>

          <section-basic title="Transcript">
            <div
              class="transcript_base"
              v-if="transcript.data.transcript"
              v-html="formattedTranscript"
            />
            <p v-else>No Transcript</p>
          </section-basic>

          <section-basic title="Call Details">
            <div
              class="transcript_base"
              v-if="transcript.data.call_details"
              v-html="formattedCallDetails"
            />
            <p v-else>No Details</p>
          </section-basic>
        </div>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import { ENUMS } from "../../../services/enums";
import CommunicationItemText from "./CommunicationItemText";
import CommunicationItemCall from "./CommunicationItemCall";
import CommunicationItemEmail from "./CommunicationItemEmail";
import CommunicationItemRecords from "./CommunicationItemRecords";
import utils from "../../../services/utils";

export default {
  name: "CommunicationEntry",
  components: {
    CommunicationItemRecords,
    CommunicationItemEmail,
    CommunicationItemCall,
    CommunicationItemText,
  },
  props: {
    comm: Object,
  },
  data() {
    return {
      transcript: {
        title: "",
        subtitle: "",
        data: {},
      },
    };
  },
  computed: {
    formattedTranscript() {
      return utils.newLineString(this.transcript.data.transcript);
    },
    formattedCallDetails() {
      return utils.newLineString(this.transcript.data.call_details);
    },
  },
  methods: {
    isText(comm) {
      return comm.type === ENUMS.CommunicationTypeEnum.Text.value;
    },
    isCall(comm) {
      if (comm.type === ENUMS.CommunicationTypeEnum.VideoCall.value) {
        return true;
      }

      return comm.type === ENUMS.CommunicationTypeEnum.Call.value;
    },
    isEmail(comm) {
      return comm.type === ENUMS.CommunicationTypeEnum.Email.value;
    },
    openTranscriptModal(data) {
      this.transcript = data;
      this.$refs.transcriptModal.open();
    },
    closeTranscriptModal() {
      this.transcript = {
        title: "",
        subtitle: "",
        data: {},
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.transcript-modal {
  .section_base {
    padding: 0 0 14px;
  }

  .section_base--inner p,
  .transcript_base {
    line-height: 1.2;
    white-space: pre-line;
  }
}
</style>
